






















import Vue from 'vue'
import { brandColor, trackColor } from '../utils/Utils';

export default Vue.extend({
	
	data() {
		return {
			width: 400,
			height: 90,
			// c: 0,
			isActive: false,

			wantedProgress: 0,
			progressDirty: false,
		}
	},

	props: {
		progress: Number,
		progressMode: String,
		heightData: {
			type: Array as () => number[][]
		},
		raceLength: Number,
	},

	methods: {

		mouseOver(event:MouseEvent) {
			this.isActive = true;
			this.mouseMove(event);
		},

		touchStart(event:TouchEvent) {
			this.touchMove(event);
			this.isActive = true;
		},

		mouseOut(event:MouseEvent) {
			this.isActive = false;
			this.wantedProgress = 1;
			this.setDirty();
		},

		touchEnd(event:TouchEvent) {
			this.isActive = false;
			this.wantedProgress = 1;
			this.setDirty();
			if(event.cancelable)
				event.preventDefault(); // prevents mouse events which made line reappear on mobile
		},

		mouseMove(event:MouseEvent) {
			const bounds = (this.$refs.mouseDiv as Element).getBoundingClientRect();
			const progress = (event.clientX - bounds.left) / (this.$refs.mouseDiv as Element).clientWidth;
			this.wantedProgress = Math.max(0, Math.min(1, progress));
			this.setDirty();
		},


		touchMove(event:TouchEvent) {
			const bounds = (this.$refs.mouseDiv as Element).getBoundingClientRect();
			const finger = 50;
			const progress = (event.touches[0].clientX - bounds.left - finger/2) / ((this.$refs.mouseDiv as Element).clientWidth - finger);
			this.wantedProgress = Math.max(0, Math.min(1, progress));
			this.setDirty();
		},

		setDirty() {
			if(!this.progressDirty) {
				this.progressDirty = true;
				requestAnimationFrame(this.updateProgress);
			}
		},

		updateProgress() {
			this.$emit("setProgress", this.wantedProgress, this.isActive ? "height": undefined);
			this.progressDirty = false;
		},

		draw() {
			let canvas = (this.$refs.canvas as HTMLCanvasElement);
			if(!canvas || this.heightData.length == 0)
				return;
			

			const maxY = this.heightData.reduce((max, p) => p[1] > max ? p[1] : max, this.heightData[0][1]);
			const minY = this.heightData.reduce((min, p) => p[1] < min ? p[1] : min, this.heightData[0][1]);
			const diffY = maxY - minY;
			
			let ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			ctx.globalAlpha = 1;

			ctx.beginPath();
			ctx.moveTo(0,this.height);
			for(let pt of this.heightData) {
				ctx.lineTo(pt[0] * this.width, this.height - ((pt[1] - minY) / diffY * this.height*0.8) - this.height * 0.05);
			}
			ctx.lineTo(this.width, this.height);
			// ctx.strokeStyle = "#000";
			ctx.fillStyle = trackColor();
			// ctx.lineWidth = 2;
			ctx.imageSmoothingEnabled = true;
			ctx.fill();


			//vertical lines
			// ctx.beginPath();
			// ctx.strokeStyle = "#000000";
			// ctx.globalAlpha = 0.06;
			// ctx.lineWidth = 1;
			// const dist = 20;
			// for(let i=dist ; i<this.raceLength; i+=dist) {
			// 	const pos = Math.round(this.width/this.raceLength * i) - 0.5;
			// 	ctx.moveTo(pos,0);
			// 	ctx.lineTo(pos, this.height);
			// }
			// ctx.stroke();

			//horizontal lines
			ctx.beginPath();
			// ctx.strokeStyle = "#000000";
			// ctx.globalAlpha = 0.06;
			// ctx.lineWidth = 1;
			// ctx.fillStyle = "#444";
			
			const diff = maxY - minY;
			let stepSize = 1;
			if(diff < 5)
				stepSize = 1;
			else if(diff < 100)
				stepSize = 10;
			else if(diff < 1000)
				stepSize = 50;
			let yDist = Math.ceil(diff / 6 / stepSize) * stepSize;
			for(let i=Math.ceil(minY/yDist) * yDist ; i<maxY+100; i+=yDist) {
				const pos = Math.round(this.height - ((i - minY) / diffY * this.height*0.8) - this.height*0.05) - 0.5;
				const metrics = ctx.measureText(i.toString());
				ctx.moveTo(metrics.width + 5,pos);
				ctx.lineTo(this.width, pos);

				ctx.strokeStyle = "#000000";
				ctx.lineWidth = 2;
				ctx.globalAlpha = .35;
				const x = 3;
				ctx.strokeText(i.toString(), x, pos + 3.5)
				ctx.globalAlpha = 1;
				ctx.fillStyle = "#ffffff";
				ctx.fillText(i.toString(), x, pos + 3.5)
			}
			ctx.globalAlpha = 0.65;
			ctx.lineWidth = 0.25;
			ctx.strokeStyle = "#ffffff";
			ctx.stroke();
			
		},

		handleResize() {
			this.width = (this.$refs.mouseDiv as HTMLElement).clientWidth;

			const canvas = (this.$refs.canvas as HTMLCanvasElement);
			let ctx = canvas.getContext("2d");
			var dpr = window.devicePixelRatio || 1;

			canvas.style.width = this.width + "px";
			canvas.style.height = this.height + "px";
			canvas.width = this.width * dpr;
			canvas.height = this.height *  dpr;
			ctx!.scale(dpr, dpr);

			this.draw();
		},
	},

	computed: {
		currentHeight() {
			let after = this.heightData.findIndex(pt =>  pt[0] > this.progress);
			if(after == -1)
				after = this.heightData.length-1;
			
			let before = after > 0 ? after-1 : 0;

			let progress = (this.progress - this.heightData[before][0]) / (this.heightData[after][0] - this.heightData[before][0]);
			let value = (this.heightData[after][1] - this.heightData[before][1]) * progress + this.heightData[before][1];
			return Math.round(value);
		},

		currentDist() {
			return ((Math.floor(this.progress * this.raceLength * 10)/10).toFixed(1));
		},

		badgeStyle():any {

			const badgeWidth = 50; //sync with css
			let x = this.progress * this.width - badgeWidth/2;
			x = Math.max(0, Math.min(x, this.width - badgeWidth));

			return {
				'left': x + 'px',
			}
		},

		showProgress():boolean {
			return this.isActive || (this.progressMode != "" && this.progressMode != 'height');
		}

	},

	watch: {
		heightData: {
			handler: function (heightData) {
				this.draw();
			}
		}
	},

	mounted: function () {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
		this.draw();
	},

	beforeDestroy: function () {
		window.removeEventListener('resize', this.handleResize);
	}
});

